import Cbu from './components/Cbu';

export default Cbu;
